import {Record} from 'immutable';

const Kit = Record({
  id: null,
  link: null,
  token: '',
  name: '',
  subsetName: '',
  archived: false,
  version: 0,
  migrating: false,
  downloadedAt: null,
  downloadCount: null,
  downloadable: false,
  needsPublishing: false,
  publishable: false,
  publishStatus: null,
  publishText: '',
  hasNeverBeenPublished: false,
  shareableDocumentationPath: '',
});

export default Kit;



// WEBPACK FOOTER //
// ./app/javascript/records/Kit.js